var mixin = {
  data () {
    return {
      isDirty: false
    }
  },
  methods: {
    onChangesSaved: function () {
      this.isDirty = false
    },
    onChangesCancelled: function () {
      this.isDirty = false
    },
    onFormChange: function () {
      this.isDirty = true
    },
    checkDirty: function (next) {
      if (this.isDirty) {
        if (confirm('You have un-saved changes. Do you wish to discard these changes?')) {
          next()
        }
      } else {
        next()
      }
    },
    validateBeforeSubmit () {
      if (this.serverErrors) {
        this.serverErrors = []
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.onSave()
        } else {
          if (this.onValidationFailure) {
            this.onValidationFailure()
          }
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))
          this.$goToFirstValidationError(this.$validator.errors.items)
        }
      })
    },
    validateBeforeSubmitWithCallBack (onSave) {
      if (this.serverErrors) {
        this.serverErrors = []
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (typeof onSave === 'function') {
            onSave()
          } else if (typeof this.onSave === 'function') {
            this.onSave()
          }
        } else {
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))
          this.$goToFirstValidationError(this.$validator.errors.items)
        }
      })
    },
    validateBeforeSubmitScoped (scope) {
      if (this.serverErrors) {
        this.serverErrors = []
      }
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.onSave()
        } else {
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))
          this.$goToFirstValidationError(this.$validator.errors.items)
        }
      })
    },
    validateBeforeSubmitAllScoped () {
      if (this.serverErrors) {
        this.serverErrors = []
      }

      this.$validator.validate().then((result) => {
        if (result) {
          this.onSave()
        } else {
          // errors.items is the app-wide shared array - every component's ErrorBag mirrors the same
          // one, so it also holds errors belonging to whatever is mounted around this form. Narrow
          // it to the errors this validator just produced before reading anything off it.
          let ownErrors = this.$validator.errors.items.filter((x) => x.vmId === this.$validator.id)
          if (ownErrors.length === 0) {
            // A handful of selector components validate against their own validator instead of the
            // form's, so their errors carry a different vmId - fall back rather than lose them.
            ownErrors = this.$validator.errors.items
          }
          // for some reason the multiselects components returns two error items for one input, first doesnt have scope but the second one has. Inputs on the form return one error item
          let errorScope = ownErrors[0] && ownErrors[0].scope ? ownErrors[0].scope : null
          if (errorScope === null) {
            errorScope = ownErrors[1] && ownErrors[1].scope ? ownErrors[1].scope : null
          }

          if (errorScope !== null) {
            // cater for double digit tabs length
            let pageIndex = (errorScope.length === 6) ? errorScope.slice(-1) - 1 : errorScope.slice(-2) - 1
            this.tabIndex = pageIndex
          }

          if (this.onValidationFailure) {
            this.onValidationFailure()
          }
          document.querySelectorAll('.header-collapsed').forEach((x) => x.classList.remove('header-collapsed'))

          this.$nextTick(() => { this.$goToFirstValidationError(ownErrors) })
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.checkDirty(next)
  }
}

export default mixin
